import { List as ContactsList } from './List';

export default ContactsList;
